import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { hasFeature } from "src/generator/hooks/useCopyVal";
import {
  calcFgasEq,
  FGAS_EQ_FEATURE,
  FGAS_TAGS,
} from "src/generator/utils/fgas";
import { findColIdByTag } from "src/generator/utils/rowTags";

interface Props {
  id: string;
  feature?: string | string[];
  cols?: Record<string, any>;
}

const useFgasEqCalc = ({ id, feature, cols }: Props) => {
  const { subscribe, setValue } = useFormContext();
  const enabled = hasFeature(feature, FGAS_EQ_FEATURE);
  const gwpId = enabled ? findColIdByTag(cols, FGAS_TAGS.gwp, id) : undefined;
  const eqId = enabled ? findColIdByTag(cols, FGAS_TAGS.eq, id) : undefined;

  useEffect(() => {
    if (!gwpId || !eqId) return;

    return subscribe({
      name: [id, gwpId],
      formState: { values: true },
      callback: ({ values, name }) => {
        if (name !== id && name !== gwpId) return;
        setValue(eqId, calcFgasEq(values[id], values[gwpId]));
      },
    });
  }, [eqId, gwpId, id, setValue, subscribe]);
};

export default useFgasEqCalc;
